import React, { useEffect } from 'react'

const ExternalRoute = ({ redirectLink = '' }) => {

    // ** Effects
    useEffect(() => {
        if (redirectLink) {
            window.location.replace(redirectLink);
        }
    }, [redirectLink]);

    return null;
}

export default ExternalRoute